import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import { fetchVoucherRequestAction, updateVoucherAction } from 'src/comps/Voucher/actions'
import { updateSearchAction } from 'src/effects/Search/actions'
import { getIsFetching, getRefetch, getVoucher } from 'src/comps/Voucher/selectors'
import { typePaymentMethods } from 'client/types/checkout'
import { typeVoucher } from 'client/types/voucher'

import Loader from 'src/comps/Atom/Loader'
import Voucher from '.'
import { typeProperty } from 'client/types'

const VoucherContainer = ({
  pageId,
  paymentMethods,
  purchaseId,
  voucher: voucherFromServer,
  property,
  supportInfoJSON,
}) => {
  const dispatch = useDispatch()

  const isLoading = useSelector(getIsFetching)
  const refetch = useSelector(getRefetch)
  const voucherFromStore = useSelector(getVoucher)

  const voucher = Object.keys(voucherFromStore).length ? voucherFromStore : voucherFromServer

  useEffect(() => {
    if (refetch) {
      dispatch(fetchVoucherRequestAction({ purchaseId }))
    } else {
      dispatch(updateVoucherAction(voucherFromServer))
    }
  }, [dispatch, refetch, purchaseId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (voucher) {
      const { checkIn, checkOut } = voucher.bookingInformation[0]
      const searchParams = { checkIn, checkOut }
      dispatch(updateSearchAction(searchParams))
    }
  }, [dispatch, voucher])

  if (isLoading) {
    return <Loader />
  }

  return (
    <Voucher
      pageId={pageId}
      paymentMethods={paymentMethods}
      purchaseId={purchaseId}
      voucher={voucher}
      property={property}
      supportInfoJSON={supportInfoJSON}
    />
  )
}

VoucherContainer.propTypes = {
  pageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  paymentMethods: typePaymentMethods,
  purchaseId: PropTypes.string,
  voucher: typeVoucher,
  property: typeProperty,
  supportInfoJSON: PropTypes.instanceOf(Object),
}

export default VoucherContainer
